import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AddressChangePageBaseComponent, ImmomioIconName } from '@resident-nx/shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ROUTE } from '../../../../models';
import { IconWebComponent, ImageWebComponent } from '@resident-nx/web/ui';
import { ImmomioAnchorComponent, ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-new-address-modal',
  templateUrl: './new-address.modal.component.html',
  styleUrls: ['./new-address.modal.component.scss'],
  imports: [
    ImageWebComponent,
    TranslatePipe,
    IconWebComponent,
    ImmomioAnchorComponent,
    ImmomioButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewAddressWebModalComponent extends AddressChangePageBaseComponent {
  public immomioIconName = ImmomioIconName;
  private router = inject(Router);
  private ngbActiveModal = inject(NgbActiveModal);

  public goToTicketsCreation() {
    this.setMovingAddressSent(this.contractId);
    this.closeModal();

    // todo check if this routing to ticket/requests really goes to requests or only ticketing 2 places ;-)
    this.router.navigate([ROUTE.TICKETS, 'requests']);
  }

  public setMovingAddressDone() {
    this.setMovingAddressSent(this.contractId);
    this.closeModal();
  }

  public closeModal() {
    this.ngbActiveModal.close();
  }
}
